import ReactPlayer from 'react-player'
import { useState, useEffect } from 'react';

const TARGET_TIME = new Date('2026-09-10T09:00:00-07:00').getTime();

const Trailers = () => {

    const [isRevealed, setIsRevealed] = useState(() => Date.now() >= TARGET_TIME);

    useEffect(() => {
        if (isRevealed) return;

        const timeRemaining = TARGET_TIME - Date.now();

        // Set a single timeout for the exact delay instead of polling
        const timer = setTimeout(() => {
        setIsRevealed(true);
        }, timeRemaining);

        return () => clearTimeout(timer);
    }, [isRevealed]);

    return (
        <>
            {
                isRevealed ? 
                <>    
                    <div className='video-container'>
                    <h1 className='trailer-title'>Launch Trailer (Nintendo Switch 2, PS5)</h1> 
                        <div className='video-wrapper'>
                            <ReactPlayer url='https://youtu.be/4vUj0nlTlGA' />
                        </div>
                    </div>
                </> : <></>
            }
            <div className='video-container'>
            <h1 className='trailer-title'>Announcement Trailer (Nintendo Switch 2, PS5)</h1> 
                <div className='video-wrapper'>
                    <ReactPlayer url='https://youtu.be/TGx4JR0kcj4' />
                </div>
            </div>
            <h1 className='trailer-title'>Launch Trailer (Nintendo Switch, PS4, PC)</h1>
            <div className='video-container'>
                <div className='video-wrapper'>
                    <ReactPlayer url='https://www.youtube.com/watch?v=S6JVtleWmdg' />
                </div>
            </div>

            <h1 className='trailer-title'>Gameplay Trailer</h1>
            <div className='video-container'>
                <div className='video-wrapper'>
                    <ReactPlayer url='https://www.youtube.com/watch?v=4QS2aUIMIac' />
                </div>
            </div>

            <h1 className='trailer-title'>Character Trailer</h1>
            <div className='video-container'>
                <div className='video-wrapper'>
                    <ReactPlayer url='https://www.youtube.com/watch?v=c46hyVWdvKc' />
                </div>
            </div>
            <h1 className='trailer-title'>Teaser Trailer (Nintendo Switch, PS4, PC)</h1>
            <div className='video-container'>
                <div className='video-wrapper'>
                    <ReactPlayer url='https://www.youtube.com/watch?v=lAOCKcEbjiY' />
                </div>
            </div>
            <h1 className='trailer-title'>Story Trailer</h1>
            <div className='video-container'>
                <div className='video-wrapper'>
                    <ReactPlayer url='https://www.youtube.com/watch?v=YVhbUvmWacU' />
                </div>
            </div>
        </>
    );
}

export default Trailers
